export class NavigationTemplate {
  public routerLinkName: string;
  public idName: string;
  public title: string;
  public text: string;

  constructor(linkName,id,title,text) {
    this.routerLinkName = linkName;
    this.idName = id;
    this.title = title;
    this.text = text;
  }
}
